// extracted by mini-css-extract-plugin
export default {"menuBlock":"QH-z","title":"RH-z","nav":"SH-z","flexCell":"TH-z","facetLink":"UH-z"};